<script lang="ts">
	import { Modal } from '@Shelly/shelly-design-system/index';
	import VideoPlayer from '../../CameraPlayer/VideoPlayer.svelte';
	import { RecordingMediaType, type CloudRecording } from '../../types/cloud-recordings';
	import ImageContainer from './ImageContainer.svelte';
	import { dateFormat } from 'src/helpers/date_helper';
	import { load_image_from } from 'src/helpers/interface_helpers';
	import { buildCloudMediaUrl } from 'src/services/cam-cloud/recordings';
	import ZoomableContainer from '../../CameraPlayer/ZoomableContainer.svelte';

	export let recording: CloudRecording;

	let showFullscreenModal = false;
	let fullscreenMedia: CloudRecording = null;

	// Build authenticated media URLs
	let videoUrl = '';
	let imageUrl = '';
	let fullscreenImageUrl = '';

	$: {
		const recordingVideoUrl = (recording as any)?.videoUrl;
		if (recordingVideoUrl) {
			buildCloudMediaUrl(recordingVideoUrl).then((url) => (videoUrl = url));
		} else {
			videoUrl = '';
		}
	}

	$: {
		if (recording?.imageUrls?.large) {
			buildCloudMediaUrl(recording.imageUrls.large).then((url) => (imageUrl = url));
		} else {
			imageUrl = '';
		}
	}

	$: {
		if (fullscreenMedia?.imageUrls?.large) {
			buildCloudMediaUrl(fullscreenMedia.imageUrls.large).then(
				(url) => (fullscreenImageUrl = url),
			);
		} else {
			fullscreenImageUrl = '';
		}
	}

	const handleImageClick = (e) => {
		fullscreenMedia = recording;
		showFullscreenModal = true;
	};

	const handleCloseModal = () => {
		showFullscreenModal = false;
		fullscreenMedia = null;
	};

	$: formattedDate = fullscreenMedia ? dateFormat(fullscreenMedia.date, 'd M H:i:s') : '';
</script>

<div
	class={'placeholder-container' +
		' ' +
		(recording?.type === RecordingMediaType.IMAGE ? 'image' : 'video')}
>
	{#if recording?.type === RecordingMediaType.VIDEO && videoUrl}
		<VideoPlayer borderRadius="big" videoSrc={videoUrl} />
	{:else if recording?.type === RecordingMediaType.IMAGE && imageUrl}
		<ImageContainer size="full" aspectRatio="16-9" src={imageUrl} on:click={handleImageClick} />
	{:else}
		<ImageContainer
			size="full"
			aspectRatio="16-9"
			src={load_image_from('images/device_images/logo_white_S.png')}
		/>
	{/if}
</div>

<Modal
	on:close={handleCloseModal}
	showModal={showFullscreenModal}
	title={formattedDate}
	backdropClose={true}
>
	<svelte:fragment slot="content">
		{#if fullscreenImageUrl}
			<ZoomableContainer>
				<ImageContainer size="full" aspectRatio="16-9" src={fullscreenImageUrl} />
			</ZoomableContainer>
		{/if}
	</svelte:fragment>
</Modal>

<style>
	.placeholder-container {
		aspect-ratio: 16/9;
		width: 100%;
		border-radius: var(--radius-big);
		overflow: hidden;
	}

	.placeholder-container.image {
		cursor: pointer;
	}
</style>
